import React, {useState} from 'react';

const Message = ( props ) => {
	
	const [ companyNameClass, setCompanyNameClass ] = useState(null)

	const company_name_complete = () => {
		return props.params.company_name.length > 0 ? true : false
	}

	const handleClick = ( type, e ) => {
		setCompanyNameClass(null)
		if( props.product.vat_receipt && !company_name_complete() ) {
			setCompanyNameClass('animated shakeme input_error')
			return false
		} else {
			switch( type ) {
				case 'facebook':
					props.handleFacebookLogin( e )
					break
				case 'signup':
					props.handleViewChange('signup', e)
					break
				case 'login':
					props.handleViewChange('login', e)
					break
				default:
					return false
			}
		}
	}

	return (
		<div className="grid-x grid-margin-x">

			{props.product.vat_receipt ? (
				<div className="cell medium-12 authMessageHolder">

				<label>
					<span className="form-label">Your Company/Group Name</span>
					<input type="text" name="company_name" placeholder="Your Company/Group Name" value={props.params.company_name} onChange={props.handleBookingInput} className={companyNameClass} />
				</label>

				</div>
			) : null}

			<div className="cell medium-12 authMessageHolder">
				<label>
					{props.product.vat_receipt ? (
						<span className="form-label">Message for {props.product.supplier.name}</span>
					) : (
						<h3>Message for {props.product.supplier.name}</h3>
					)}
					<textarea
						className="authMessage"
						rows="5"
						name="message_text"
						onChange={props.handleBookingInput}
						value={props.params.message_text}
						placeholder={props.product.instantBook ? 'Please let the supplier know if you have any questions regarding your booking' : null}
					>
					</textarea>
				</label>
			</div>

			{1==2 && (
			<div className="cell small-12 signup-details">
				<label className="checkbox inline"  htmlFor="optin-privacy">
				<input type="checkbox" id="optin-privacy" checked={props.optoutMarketing} name="user[optin-marketing]" value="1" onChange={props.handleMarketingOptout} />
					<span> OK: Tick this box if you would not like to receive Book a Party marketing offers and promotions via email. </span>
				</label>
				<p>By continuing you agree to be contacted by Book a Party and the relevant activity suppliers and have read and understood the <a href="/privacy" target="_blank">Privacy Notice</a></p>
			</div>
			)}

			<div className="cell small-12 text-center">
				<p>
					<button
						className="button primary expanded"
						onClick={(e) => handleClick('signup',e)}>
							Continue with email
					</button>
				</p>
				<p>Have an account? <a onClick={(e) => handleClick('login',e)}>Login</a></p>
			</div>
		</div>
	)
}

export default Message
